import { render, staticRenderFns } from "./purchaseMethod.vue?vue&type=template&id=9c83007e&scoped=true"
import script from "./purchaseMethod.vue?vue&type=script&lang=js"
export * from "./purchaseMethod.vue?vue&type=script&lang=js"
import style0 from "./purchaseMethod.vue?vue&type=style&index=0&id=9c83007e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c83007e",
  null
  
)

export default component.exports